import { render, staticRenderFns } from "./SoftwareCapabilities.vue?vue&type=template&id=80839416"
import script from "./SoftwareCapabilities.vue?vue&type=script&lang=js"
export * from "./SoftwareCapabilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports